import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i3 from "../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
function AutocompleterMultiSelectListComponent_div_2_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵelement(2, "div", 8);
    i0.ɵɵelementStart(3, "div", 9)(4, "div", 10);
    i0.ɵɵlistener("click", function AutocompleterMultiSelectListComponent_div_2_ng_container_1_div_1_Template_div_click_4_listener() { i0.ɵɵrestoreView(_r1); const selectedItem_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.removeItem(selectedItem_r2)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 11);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const selectedItem_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", selectedItem_r2.item.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-close");
} }
function AutocompleterMultiSelectListComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AutocompleterMultiSelectListComponent_div_2_ng_container_1_div_1_Template, 6, 2, "div", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const selectedItem_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", selectedItem_r2.item.type === ctx_r2.autocompleterName);
} }
function AutocompleterMultiSelectListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, AutocompleterMultiSelectListComponent_div_2_ng_container_1_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.selectedItems);
} }
/**
 * Autocompleter Multi Select List Component
 *
 * Allows the selection of a multiple results from an autocompleter and displays the selected results
 * below the autocompleter input box.
 *
 * Input Properties:
 *  autocompleterName: type of things to search for in base autocomplete.
 *  autocompleterPlaceholder: string to show in the autocompleter input box when it is empty.
 *  selectedItems: MultiSelectSecurityListItem[] that contains the currently selected security lists and their security groups.
 *
 * Output Properties:
 *  removeItemHandler: emits the item that the X button was clicked for
 *  selectItemHandler: emits the item that was selected from the autocomplete field
 */
export class AutocompleterMultiSelectListComponent {
    constructor() {
        this.removeItemHandler = new EventEmitter();
        this.selectItemHandler = new EventEmitter();
    }
    removeItem(itemToRemove) {
        this.removeItemHandler.emit(itemToRemove);
    }
    selectItem(item) {
        this.selectItemHandler.emit(item);
    }
}
AutocompleterMultiSelectListComponent.ɵfac = function AutocompleterMultiSelectListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AutocompleterMultiSelectListComponent)(); };
AutocompleterMultiSelectListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AutocompleterMultiSelectListComponent, selectors: [["ycn-autocompleter-multi-select-list"]], inputs: { autocompleterName: "autocompleterName", autocompleterPlaceholder: "autocompleterPlaceholder", selectedItems: "selectedItems" }, outputs: { removeItemHandler: "removeItemHandler", selectItemHandler: "selectItemHandler" }, standalone: false, decls: 3, vars: 4, consts: [[1, "linked-list-body-content"], [3, "submitHandler", "appendToBody", "placeholder", "searchType"], ["class", "options-list", 4, "ngIf"], [1, "options-list"], [4, "ngFor", "ngForOf"], ["class", "options-list-item", 4, "ngIf"], [1, "options-list-item"], [1, "options-list-item-header"], [1, "options-list-item-title", 3, "textContent"], [1, "options-list-item-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", 3, "name"]], template: function AutocompleterMultiSelectListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ycn-icon-search-autocomplete", 1);
        i0.ɵɵlistener("submitHandler", function AutocompleterMultiSelectListComponent_Template_ycn_icon_search_autocomplete_submitHandler_1_listener($event) { return ctx.selectItem($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, AutocompleterMultiSelectListComponent_div_2_Template, 2, 1, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("appendToBody", false)("placeholder", ctx.autocompleterPlaceholder)("searchType", ctx.autocompleterName);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selectedItems && ctx.selectedItems.length);
    } }, dependencies: [i1.NgForOf, i1.NgIf, i2.IconDirective, i3.IconSearchAutocompleteComponent], encapsulation: 2 });
